'use client'

import { useTranslations } from '@/lib/next-shim'
import { PlusIcon } from '@heroicons/react/24/outline'

import { SavedAddressList } from '@/shared/ui/address/SavedAddressList'

import type { ProfileAddress, SavedAddress } from '../model/types'

type SavedAddressesViewProps = {
  savedAddresses: SavedAddress[]
  onSelect: (address: SavedAddress) => void
  onDelete?: (addressId: string) => void
  profileAddress?: ProfileAddress | null
  showProfileQuickPick: boolean
  onSelectProfile: () => void
  onNewAddress: () => void
}

export function SavedAddressesView({
  savedAddresses,
  onSelect,
  onDelete,
  profileAddress,
  showProfileQuickPick,
  onSelectProfile,
  onNewAddress,
}: SavedAddressesViewProps) {
  const t = useTranslations('address')

  return (
    <>
      <div>
        <p className="block text-sm font-medium leading-6 text-gray-900 mb-2">{t('savedAddresses')}</p>
        <SavedAddressList addresses={savedAddresses} onSelect={onSelect} onDelete={onDelete} />
      </div>

      {/* Profile address quick-pick */}
      {showProfileQuickPick && profileAddress && (
        <button
          type="button"
          onClick={onSelectProfile}
          className="w-full text-left px-4 py-3 border border-dashed border-gray-300 rounded-lg hover:bg-gray-50"
        >
          <p className="text-sm font-medium text-gray-700">{t('profileAddress')}</p>
          <p className="text-sm text-gray-500">
            {profileAddress.street}, {profileAddress.cp} {profileAddress.city}
          </p>
        </button>
      )}

      <button type="button" onClick={onNewAddress} className="inline-flex items-center gap-1 text-sm text-indigo-600 hover:text-indigo-500">
        <PlusIcon className="h-4 w-4" />
        {t('newAddress')}
      </button>
    </>
  )
}
